class BlueCheckbox extends Checkbox {
    constructor(label: string, controller: Controller, oldContainer: JQuery, checkboxGroup: CheckboxGroup, mode: string) {
        super(oldContainer.attr("value"), label, controller, oldContainer, checkboxGroup, mode);
    }

    initHTML(oldElement, label) {
        var newHTML = '';

        newHTML += '<div class="check_option">';
        newHTML += '    <div class="check_option_circle">&nbsp;</div>';
        newHTML += '    <div class="check_option_label">' + label + '</div>';
        newHTML += '</div>';

        this.container = $(newHTML);

        oldElement.replaceWith(this.container);
    }

    setEnabled(enabled) {
        this.container.toggleClass("disabled", !enabled);
    }

    isEnabled(): boolean {
        return !this.container.hasClass("disabled");
    }

    previewEnabled(enabled) {
        if (enabled && this.container.hasClass("disabled")) {
            this.container.addClass("feedforward_enabled");
        } else if (!enabled && !this.container.hasClass("disabled")) {
            this.container.addClass("feedforward_disabled");
        }
    }

    setSelected(selected) {
        this.container.toggleClass("selected", selected);
    }

    isSelected() {
        return this.container.hasClass("selected");
    }

    previewSelected(selected) {
        if(this.container.hasClass("selected") && !selected) {
         //   this.container.css({
         //       background: "-webkit-gradient(linear, left top, right top, from("+color1+"), to("+color2+"))"}).css({
         //   background: "-moz-linear-gradient(left, "+color1+" 0%, "+color2+" 100%)"});

            this.container.addClass("feedforward_deselected");
        } else if(!(this.container.hasClass("selected")) && selected) {
            this.container.addClass("feedforward_selected");
        }
    }

    isVisible(): boolean {
        return false;
    }

    previewVisible(visible: boolean, timeRatioLeft: number) {
    }

    removePreviewEnabled() {
        // TODO
    }

    removePreviewSelected() {
        this.container.removeClass("feedforward_selected feedforward_deselected");
    }
}